import { useWorkspaceSettings } from "@/hooks/use-workspace-settings";
import { SettingsRow } from "./settings-row";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import posthog from "posthog-js";

export default function MembersSettings() {
  const { workspace, isLoading, activeWorkspaceId, updateWorkspaceMutation } =
    useWorkspaceSettings();

  const [settings, setSettings] = useState({
    judges_get_email: false,
    show_judge_on_opportunity: false,
  });
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    if (workspace) {
      setSettings({
        judges_get_email: workspace.judges_get_email,
        show_judge_on_opportunity:
          workspace.show_judge_on_opportunity || false,
      });
    }
  }, [workspace]);

  useEffect(() => {
    if (!workspace) return;
    const changed =
      settings.judges_get_email !== workspace.judges_get_email ||
      settings.show_judge_on_opportunity !==
        (workspace.show_judge_on_opportunity || false);
    setHasChanges(changed);
  }, [settings, workspace]);

  const handleSave = () => {
    updateWorkspaceMutation.mutate(settings, {
      onSuccess: () => {
        posthog.capture("settings_workspace_team_updated", {
          workspace_id: activeWorkspaceId,
          updated_fields: settings,
        });
      },
    });
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl px-6 py-8">
      <h1 className="text-lg font-semibold text-foreground">Members</h1>
      <p className="mt-0.5 text-sm text-muted-foreground">
        Configure team member visibility and notification preferences.
      </p>

      <section className="mt-8">
        <h2 className="mb-3 text-xs font-medium uppercase tracking-widest text-muted-foreground/50">
          Notifications
        </h2>
        <div className="rounded-lg border border-border bg-card px-4">
          <SettingsRow
            title="Email Notifications"
            description="Send email notifications to team members"
          >
            <Switch
              checked={settings.judges_get_email}
              onCheckedChange={(checked) =>
                setSettings((prev) => ({
                  ...prev,
                  judges_get_email: checked,
                }))
              }
            />
          </SettingsRow>
          <SettingsRow
            title="Team Member Visibility"
            description="Show team members on the opportunity page"
          >
            <Switch
              checked={settings.show_judge_on_opportunity}
              onCheckedChange={(checked) =>
                setSettings((prev) => ({
                  ...prev,
                  show_judge_on_opportunity: checked,
                }))
              }
            />
          </SettingsRow>
        </div>
      </section>

      {hasChanges && (
        <div className="mt-8 flex justify-end">
          <Button
            onClick={handleSave}
            disabled={updateWorkspaceMutation.isPending}
          >
            {updateWorkspaceMutation.isPending ? "Saving..." : "Save Changes"}
          </Button>
        </div>
      )}
    </div>
  );
}
